import { EntityDocumentViewer_FilePageFragment } from '@/modules/documents/components/HouseholdDocumentsViewer/graphql/EntityDocumentViewer.generated';

import { PDFFilePage } from '../types';

/**
 * Converts GraphQL FilePage objects to the normalized PDFFilePage format
 * This handles unit conversion (if present) and maps the fields correctly
 *
 * @param filePages - The array of GraphQL FilePage objects to convert
 * @returns An array of normalized PDFFilePage objects
 */
export function convertGraphQLFilePages(
  filePages?: EntityDocumentViewer_FilePageFragment[] | null
): PDFFilePage[] {
  if (!filePages?.length) {
    return [];
  }

  return filePages.map((page) => {
    // Convert dimensions based on units
    // Default to keeping original values if no unit specified
    let widthInches = page.width;
    let heightInches = page.height;

    // If unit is specified, convert to inches if needed
    if (page.unit && page.width && page.height) {
      if (page.unit.toLowerCase() === 'mm') {
        // Convert mm to inches (1 inch = 25.4 mm)
        widthInches = page.width / 25.4;
        heightInches = page.height / 25.4;
      } else if (page.unit.toLowerCase() === 'cm') {
        // Convert cm to inches (1 inch = 2.54 cm)
        widthInches = page.width / 2.54;
        heightInches = page.height / 2.54;
      }
      // If unit is already 'in' (inches), no conversion needed
    }

    return {
      pageNumber: page.pageNumber,
      widthInches,
      heightInches,
    };
  });
}
